import React, { CSSProperties, useEffect } from 'react'
import { observer, useLocalObservable } from 'mobx-react-lite'
import { Avatar, Tag } from 'antd'
import { DeliveryItem } from '@/domains/hooks/useDelivery'
import { UserInfo } from '@/domains/hooks/useUser'

type Store = {
  taskSizes: {
    name: string
    color: string
    count: number
  }[]
}

const TaskSizeDesc = {
  0: 'S',
  1: 'M',
  2: 'L',
  3: 'XL'
}

const TaskSizeColor = {
  0: '#D7F4D2',
  1: '#DAF0FC',
  2: '#F9E9CD',
  3: '#F8DFDE'
}

function ParticipantItem(props: {
  userInfo: UserInfo
  items: { style: CSSProperties; data: DeliveryItem }[]
  onClick: (deliveryItem: DeliveryItem) => void
}): JSX.Element {
  const { userInfo, items, onClick } = props
  const { userAvatar, userName } = userInfo || {}

  const store = useLocalObservable<Store>(() => ({
    taskSizes: []
  }))

  useEffect((): void => {
    if (items.length > 0) {
      const taskSizeRecord = {}

      items.forEach((item) => {
        if (item.data.taskSize !== undefined) {
          if (!taskSizeRecord[item.data.taskSize]) {
            taskSizeRecord[item.data.taskSize] = 0
          }

          taskSizeRecord[item.data.taskSize] += 1
        }
      })

      store.taskSizes = Object.keys(taskSizeRecord).map((val) => {
        return {
          name: TaskSizeDesc[val],
          color: TaskSizeColor[val],
          count: taskSizeRecord[val]
        }
      })

      console.log(store.taskSizes)
    }
  }, [items])

  return (
    <div className="participant-card-item">
      <div className="w-full flex flex-row justify-between">
        <div className="flex flex-row justify-start items-center">
          <Avatar src={userAvatar} size={36} />
          <span style={{ width: 80, textAlign: 'left', marginLeft: 10 }}>
            {userName}
          </span>
          <span style={{ color: '#999' }}>共{items && items.length}项</span>
        </div>
        {/* <div className="flex flex-row justify-end items-center">
          <span style={{ margin: 10 }}>工作量：</span>
          {store.taskSizes.map((item) => (
            <div style={{ marginRight: 20 }}>
              <Tag
                style={{
                  fontSize: 14,
                  padding: '2px 15px',
                  fontWeight: '500',
                  color: '#000'
                }}
                color={item.color}
              >
                {item.name}
              </Tag>
              x{item.count}
            </div>
          ))}
        </div> */}
      </div>
      <div className="w-full flex flex-row flex-wrap" style={{ marginTop: 10 }}>
        {items.map((item) => (
          <div
            key={item.data.taskName}
            className="flex items-center"
            style={{ margin: '5px 15px 5px 0' }}
          >
            <Tag
              style={{
                height: 32,
                lineHeight: '28px',
                fontSize: 14,
                padding: '2px 15px',
                fontWeight: '500',
                color: '#000',
                marginRight: 0,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0
              }}
              color={TaskSizeColor[item.data.taskSize]}
            >
              {TaskSizeDesc[item.data.taskSize]}
            </Tag>
            <div
              key={item.data.id}
              style={{
                cursor: 'pointer',
                borderRadius: 4,
                padding: '5px 15px',
                ...item.style,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0
              }}
              onClick={(e) => {
                e.stopPropagation()
                onClick(item.data)
              }}
            >
              {item.data.taskName}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default observer(ParticipantItem)
